import * as type from './types';
import { createReducer } from "../../util/index";

const initialState = {
    loading: false,
    data: [],
};

const voucherSettingReducer = createReducer(initialState) ({
    [type.VOUCHER_SETTING_LIST]: (state, action) => ({
        ...state,
        voucher_setting_list: action.payload
    }),
    
    [type.UPDATE_VOUCHER_SETTING_STATUS]: (state, action) => ({
        ...state,
        update_voucher_setting_status: action.payload
    }),
});

export default voucherSettingReducer;